export { default } from './client-job-info';
